export default __webpack_public_path__ + "static/media/JobsIcon.ade21a6d.svg";